/* eslint-disable */
import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Bookings from './Bookings.jsx';
import About from './About.jsx';
import Gallery from './Gallery.jsx';
import Drink from './Drink.jsx';
import Banquets from './Banquets.jsx';
import Eat from './Eat.jsx';
import Contact from './Contact.jsx';
import Vouchers from './Vouchers.jsx';
import Functions from './Functions.jsx';
import LOS from './LOS.jsx';
import PrivateDining from './PrivateDining';
import Careers from './Careers';
import Popup from './Popup';
import Takeaway from './Takeaway';
// import ImagePopup from './ImagePopup';

// import Sidebar from './Sidebar.jsx';
// import ContactForm from './ContactForm.jsx';

import { getPages } from '../modules/api';

// eslint-disable-next-line
class Home extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			splashActive: true,
			navMenuDisplay: false,
			selectedNav: null,
			mapLoad: false,
			sideBarOpen: false,
			contactFormOpen: false,
			pages: {},
		};

		this.navMenuToggle = this.navMenuToggle.bind(this);
		this.navSwitch = this.navSwitch.bind(this);
		this.displayContentBox = this.displayContentBox.bind(this);
		this.displayAbout = this.displayAbout.bind(this);
		this.linkToBanquets = this.linkToBanquets.bind(this);
		this.openBookingWidget = this.openBookingWidget.bind(this);
	}

	componentDidMount() {
		getPages().then(res => {
			const pagesArray = res.body;
			const pagesByNav = pagesArray.reduce((prev, page) => {
				const { body_html, title, images, status } = page;
				if (title.includes('Bookings')) {
					return { ...prev, bookings: body_html };
				}
				if (title.includes('Eat')) {
					return { ...prev, eat: body_html };
				}
				if (title.includes('Drink')) {
					return { ...prev, drink: body_html };
				}
				if (title.includes('About')) {
					return { ...prev, about: body_html };
				}
				if (title.includes('Banquet')) {
					return { ...prev, banquets: body_html };
				}
				if (title.includes('LOS')) {
					return { ...prev, los: body_html };
				}
				if (title.includes('Functions')) {
					return { ...prev, functions: body_html };
				}
				if (title.includes('Private Dining')) {
					return { ...prev, private: body_html };
				}
				if (title.includes('Takeaway')) {
					return { ...prev, takeaway: body_html };
				}
				if (title.includes('Gallery')) {
					return { ...prev, gallery: images };
				}
				if (title.includes('Careers')) {
					return { ...prev, careers: body_html };
				}
				if (title.includes('Popup') && status === 'active') {
					return { ...prev, popup: body_html };
				}
				return prev;
			}, {});
			this.setState({ pages: pagesByNav })
		});

		if (this.props.match.params.section) {
			const section = this.props.match.params.section;
			if (section === 'eat') {
				this.setState({
					selectedNav: 'Eat',
					splashActive: false,
				});
			} else if (section === 'bookings') {
				this.setState({
					selectedNav: 'Bookings',
					splashActive: false,
				});
			} else if (section === 'functions') {
				this.setState({
					selectedNav: 'Functions',
					splashActive: false,
				});
			} else if (section === 'banquets' || section === 'banquet') {
				this.setState({
					selectedNav: 'Banquets',
					splashActive: false,
				});
			} else if (section === 'gallery') {
				this.setState({
					selectedNav: 'Gallery',
					splashActive: false,
				});
			} else if (section === 'about') {
				this.setState({
					selectedNav: 'About',
					splashActive: false,
				});
			} else if (section === 'drink') {
				this.setState({
					selectedNav: 'Drink',
					splashActive: false,
				});
			} else if (section === 'vouchers') {
				this.setState({
					selectedNav: 'Vouchers',
					splashActive: false,
				});
			} else if (section === 'contact') {
				this.setState({
					selectedNav: 'Contact',
					splashActive: false,
				});
			} else if (section === 'los') {
				this.setState({
					selectedNav: 'LOS',
					splashActive: false,
				});
			} else if (section === 'careers') {
				this.setState({
					selectedNav: 'Careers',
					splashActive: false,
				});
			}
			// else if (section === 'takeaway') {
			// 	this.setState({
			// 		selectedNav: 'Takeaway',
			// 		splashActive: false,
			// 	});
			// }
		}
	}

	navMenuToggle(e) {
		e.preventDefault();
		this.setState({ navMenuDisplay: !this.state.navMenuDisplay });
	}

	navSwitch(e) {
		e.preventDefault();
		this.setState({
			selectedNav: e.target.name,
			navMenuDisplay: false,
		});
	}

	linkToBanquets(e) {
		e.preventDefault();
		this.setState({
			selectedNav: 'Banquets',
			navMenuDisplay: false,
		});
	}

	displayAbout(e) {
		e.preventDefault();
		this.setState({
			splashActive: false,
			selectedNav: 'About',
		});
	}

	displayContentBox(e) {
		e.preventDefault();
		this.setState({
			splashActive: false,
			navMenuDisplay: true,
		});
	}

	openBookingWidget() {
		this.setState({
			splashActive: false,
			selectedNav: 'Bookings',
		});
	}

	render() {
		return (
			<div className="body-container">
				{this.state.pages.popup ? <Popup selectedNav={this.state.selectedNav} body={this.state.pages.popup} /> : null}
				{/* <TakeawayPopup goToTakeaway={() => this.setState({ splashActive: false, selectedNav: 'Takeaway' })} /> */}
				{/* <ImagePopup /> */}
				{/* <Sidebar
					open={this.state.sideBarOpen}
					closeSidebar={() => this.setState({ sideBarOpen: false })}
					openContactForm={() => this.setState({ contactFormOpen: true })}
				/> */}
				{/* <ContactForm
					contactFormOpen={this.state.contactFormOpen}
					closeContactForm={() => this.setState({ contactFormOpen: false })}
				/> */}
				<a
					href="#menu"
					className={`splash-menu-link${this.state.splashActive ? '' : ' hide'}`}
					onClick={evt => this.displayContentBox(evt)}
				>
					&#9776;
				</a>
				<ReactCSSTransitionGroup
					transitionName="fade"
					transitionEnterTimeout={500}
					transitionLeave={false}
					className="main-page-container"
				>
					{
						this.state.splashActive ?
							<a
								href="#menu"
								className="splash-logo-container animated fadeIn"
								onClick={evt => this.displayAbout(evt)}
								key={this.state.splashActive}
							>
								<img src="/imgs/logo-home.svg" alt="" style={{ width: '100%' }} />
							</a> :
							<div
								className="main-content-container"
								key={this.state.splashActive}
							>
								<div className="header-container">
									<div className="header-logo-box">
										<img src="/imgs/logo-home.svg" alt="" style={{ height: '100%' }} />
									</div>
									{
										this.state.selectedNav ?
											<a href="" className="header-nav-icon-container" onClick={this.navMenuToggle}>
												&#9776;
											</a> : null
									}
								</div>
								<div
									className={`header-nav-menu-container ${this.state.navMenuDisplay ? 'nav-show' : 'nav-hide'}`}
								>
									<div className="header-nav-group">
										<a
											href="/eat"
											className="header-nav-link"
											name="Eat"
											onClick={this.navSwitch}
										>
											EAT
										</a>
										<a
											href="/banquets"
											className="header-nav-link"
											name="Banquets"
											onClick={this.navSwitch}
										>
											BANQUET
										</a>
										<a
											href="/gallery"
											className="header-nav-link"
											name="Gallery"
											onClick={this.navSwitch}
										>
											GALLERY
										</a>
									</div>
									<div className="header-nav-group">
										<a
											href="/drink"
											className="header-nav-link"
											name="Drink"
											onClick={this.navSwitch}
										>
											DRINK
										</a>
										<a
											href="/los"
											className="header-nav-link"
											name="LOS"
											onClick={this.navSwitch}
										>
											LOS BAR
										</a>
										<a
											href="/vouchers"
											className="header-nav-link"
											name="Vouchers"
											onClick={this.navSwitch}
										>
											VOUCHERS
										</a>
									</div>
									<div className="header-nav-group">
										<a
											href="/about"
											className="header-nav-link"
											name="About"
											onClick={this.navSwitch}
										>
											ABOUT
										</a>
										<a
											href="/functions"
											className="header-nav-link"
											name="Functions"
											onClick={this.navSwitch}
										>
											FUNCTIONS
										</a>
										<a
											href="/careers"
											className="header-nav-link"
											name="Careers"
											onClick={this.navSwitch}
										>
											CAREERS
										</a>
									</div>
									<div className="header-nav-group">
										<a
											href="/bookings"
											className="header-nav-link"
											name="Bookings"
											onClick={this.navSwitch}
										>
											BOOKINGS
										</a>
										<a
											href="/private-dining"
											className="header-nav-link"
											name="Private Dining"
											onClick={this.navSwitch}
										>
											PRIVATE DINING
										</a>
										{/* <a
											href="/takeaway"
											className="header-nav-link"
											name="Takeaway"
											onClick={this.navSwitch}
										>
											TAKEAWAY
										</a> */}
									</div>
								</div>
								{
									this.state.selectedNav ?
										<div className={`main-content-body ${this.state.navMenuDisplay ? 'body-bottom' : 'body-top'}`}>
											<ReactCSSTransitionGroup
												transitionName="fade"
												transitionEnterTimeout={500}
												transitionLeave={false}
											>
												<div>
													<Bookings
														body={this.state.pages.bookings}
														open={this.state.selectedNav === 'Bookings'}
													/>
													{
														// eslint-disable-next-line
														this.state.selectedNav === 'About' ?
															<About
																body={this.state.pages.about}
																openBookingSidebar={() => this.setState({ sideBarOpen: true })}
															/> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Gallery' ?
															<Gallery images={this.state.pages.gallery} /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Drink' ?
															<Drink body={this.state.pages.drink} /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Banquets' ?
															<Banquets body={this.state.pages.banquets} /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Eat' ?
															<Eat body={this.state.pages.eat} /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Contact' ?
															<Contact mapLoad={this.state.mapLoad} /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Vouchers' ?
															<Vouchers /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Functions' ?
															<Functions body={this.state.pages.functions} /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'LOS' ?
															<LOS body={this.state.pages.los} /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Private Dining' ?
															<PrivateDining body={this.state.pages.private} /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Takeaway' ?
															<Takeaway /> :
														// eslint-disable-next-line
														this.state.selectedNav === 'Careers' ?
															<Careers body={this.state.pages.careers} /> : null
													}
												</div>
											</ReactCSSTransitionGroup>
										</div> : null
								}
								{
									this.state.selectedNav ?
										<div>
											<div className="main-content-footer">
												<div className="footer-social-box">
													{(this.state.selectedNav !== 'Takeaway' && this.state.selectedNav !== 'Bookings') && (
														<a
															href="#book"
															className="footer-booking-btn"
															onClick={(e) => {
																e.preventDefault();
																this.openBookingWidget();
															}}
														>
															BOOK NOW
														</a>
													)}
													<a href="https://www.instagram.com/same.same.restaurant/" target="_blank" rel="noopener noreferrer">
														<i className="fa fa-instagram" aria-hidden="true" />
													</a>
													<a href="https://www.facebook.com/sAmesAmeRestaurantAU/" target="_blank" rel="noopener noreferrer">
														<i className="fa fa-facebook" aria-hidden="true" />
													</a>
												</div>
												<div className="footer-info-box">
													<div className="footer-info-address-box">
														<div>Shop AM3 Ada Lane</div>
														<div>46 James Street</div>
														<div>Fortitude Valley, 4006</div>
													</div>
													<div className="footer-info-contact-box">
														<div>Phone: <a href="tel:0731881418">(07) 3188 1418</a></div>
														<div>
															<a href="mailto:seatme@samesamerestaurant.com.au">seatme@samesamerestaurant.com.au</a>
														</div>
													</div>
												</div>
											</div>
											<div className="main-content-footer__bottom">
												<span>
													MEET THE FAMILY
												</span>
												<a
													href="/los"
													name="LOS"
													onClick={this.navSwitch}
												>
													<img name="LOS" src="/imgs/los-logo.svg" alt="los" height={14} />
												</a>
												<a
													href="https://agnesrestaurant.com.au/"
													target="_blank"
													rel="noopener noreferrer"
												>
													<img src="/imgs/agnes-logo.svg" alt="Agnes" height={16} />
												</a>
												<a
													href="https://agnesbakery.com.au/"
													target="_blank"
													rel="noopener noreferrer"
												>
													<img src="/imgs/agnes-bakery-logo.svg" alt="Agnes Bakery" height={20} />
												</a>
												<a
													href="https://honto.com.au/"
													target="_blank"
													rel="noopener noreferrer"
												>
													<img src="/imgs/honto_logo.svg" alt="honto" height={14} />
												</a>
												<a
													href="https://biancarestaurant.com.au/"
													target="_blank"
													rel="noopener noreferrer"
													style={{ paddingBottom: 2 }}
												>
													<img src="/imgs/bianca-logo.svg" alt="bianca" height={16} />
												</a>
											</div>
										</div> : null
								}
							</div>
					}
				</ReactCSSTransitionGroup>
			</div>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/Theme/Home.jsx